import { CSSProperties } from 'react';

export const mobileSpaceCardHeight = 304;

export const mobileSpaceCardStyle: CSSProperties = {
  height: `${mobileSpaceCardHeight}px`,
};
